module.exports = __webpack_public_path__ + "img/warning-no-internet-icon.bc1add58.svg";